import clsx from "clsx";
import Balance from "ui/wallet/component/display/Balance/Balance";
import { BalanceProps } from "ui/wallet/component/display/Balance/Balance.types";

export interface RateBalanceProps extends Omit<BalanceProps, "thresholds"> {
    className?: string;
    style?: React.CSSProperties;
}

function RateBalance({ className, ...rest }: RateBalanceProps) {
    return (
        <Balance
            className={clsx("rate-balance", className)}
            thresholds={[
                {
                    value: 0.000001,
                    decimals: 6,
                },
            ]}
            {...rest}
        />
    );
}

export default RateBalance;
